interface AgentDeployment {
  properties?: {
    capabilities?: Record<string, unknown>;
    provisioningState?: unknown;
  };
}

/** Matches Logic Apps Standard's agent deployment picker, not runtime/tokenizer compatibility. */
export function isReadyChatCompletionDeployment(deployment: AgentDeployment): boolean {
  const capability = deployment.properties?.capabilities?.chatCompletion;
  const isChatCompletion =
    capability === true || (typeof capability === 'string' && capability.toLowerCase() === 'true');
  const state = deployment.properties?.provisioningState;
  // Older ARM responses can omit readiness; Standard allows those deployments.
  const isReady = state === undefined || state === '' ||
    (typeof state === 'string' && state.toLowerCase() === 'succeeded');
  return isChatCompletion && isReady;
}
